import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto pt-5" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "text-3xl font-bold mb-4" }
const _hoisted_5 = { class: "grid grid-cols-[repeat(2,_minmax(0,_1fr))_100px] gap-3 auto-rows-[1fr] grid-flow-row" }
const _hoisted_6 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_9 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_10 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_11 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_12 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_13 = { class: "px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end" }
const _hoisted_14 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_15 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_16 = { class: "px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end" }
const _hoisted_17 = { class: "px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end" }
const _hoisted_18 = { class: "px-2 whitespace-nowrap text-sm relative bg-next-gray-md-dark flex items-center justify-end" }
const _hoisted_19 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_20 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_21 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_22 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_23 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_24 = { class: "grid grid-cols-[repeat(2,_minmax(0,_1fr))_100px_50px_1fr] gap-3 auto-rows-[1fr] grid-flow-row" }
const _hoisted_25 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end translate-y-6" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_34 = { class: "text-right" }
const _hoisted_35 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_40 = { class: "text-right" }
const _hoisted_41 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end translate-y-6" }
const _hoisted_42 = { class: "text-right" }
const _hoisted_43 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_46 = { class: "text-right" }
const _hoisted_47 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_48 = { class: "text-right" }
const _hoisted_49 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_50 = { class: "text-right" }
const _hoisted_51 = { class: "px-2 flex items-center text-sm bg-next-gray-md-dark justify-end" }
const _hoisted_52 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title[_ctx.tab]) + ": " + _toDisplayString(_ctx.bi_data?.nodo), 1),
          _createVNode(_component_Switcher, {
            "model-value": _ctx.tab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
            options: _ctx.title
          }, null, 8, ["model-value", "options"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costi da ordine:", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_ordine_pos))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiPreventivo', params: { id: _ctx.id }, query: { segno: 1 } }
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Totale ordini di nota credito:", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_ordine_neg))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiPreventivo', params: { id: _ctx.id }, query: { segno: -1 } }
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costi BSP:", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_bsp))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiBiglietteriaAerea', params: { id: _ctx.id } }
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costi PICO:", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_pico))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiBiglietteriaFerroviaria', params: { id: _ctx.id } }
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costi carte:", -1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_carte_di_Credito))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiCarte', params: { id: _ctx.id } }
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costi note spesa:", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_note_spese))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiNoteSpesa', params: { id: _ctx.id } }
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold" }, "Totale costi:", -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo))), 1)
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("div", null, null, -1)),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Ordini di vendita:", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.ricavi_preventivo_pos))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'RicaviPreventivo', params: { id: _ctx.id }, query: { segno: 1 } }
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Ordini di vendita nota credito:", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.ricavi_preventivo_neg))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'RicaviPreventivo', params: { id: _ctx.id }, query: { segno: -1 } }
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold" }, "Totale vendita: ", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.ricavi_preventivo))), 1)
          ]),
          _cache[29] || (_cache[29] = _createElementVNode("div", null, null, -1)),
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold" }, "Primo margine lordo 74TER: ", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.primo_margine_preventivo) + Number(_ctx.bi_data?.iva_74TER))), 1)
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("div", null, null, -1)),
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold" }, "Primo margine:", -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.primo_margine_preventivo))), 1)
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", null, null, -1)),
          (_ctx.dividiPersonale)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costo personale esterno:", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_contratti))), 1)
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1)),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costo aziendale timesheet:", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_timesheet_proporzionato))), 1)
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", null, null, -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costo personale:", -1)),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_timesheet_proporzionato) +
                                Number(_ctx.bi_data?.costi_contratti))), 1)
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("div", null, null, -1))
              ], 64)),
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Costi finanziari:", -1)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(-Number(_ctx.bi_data?.oneri_finanziari))), 1)
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'CostiFinanziari', params: { id: _ctx.id } }
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "px-2 whitespace-nowrap text-sm justify-end flex items-center font-bold" }, "Secondo margine: ", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(
                            Number(_ctx.bi_data?.primo_margine_preventivo) -
                            Number(_ctx.bi_data?.costi_timesheet_proporzionato) +
                            Number(_ctx.bi_data?.oneri_finanziari) -
                            Number(_ctx.bi_data?.costi_contratti))), 1)
          ]),
          _cache[36] || (_cache[36] = _createElementVNode("div", null, null, -1))
        ], 512), [
          [_vShow, _ctx.tab == 0]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_24, [
          _cache[45] || (_cache[45] = _createElementVNode("h3", { class: "col-span-5 font-bold" }, "Attivo", -1)),
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Preventivo:", -1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("p", _hoisted_26, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.ricavi_preventivo_gamma))), 1)
            ])
          ]),
          _cache[47] || (_cache[47] = _createStaticVNode("<div></div><div class=\"row-span-5 grid grid-cols-2 grid-rows-8 py-5\"><span class=\"border-black border-t border-r rounded-tr-lg\">-</span><span class=\"border-black border-b\"></span><span class=\"border-black border-r border-b rounded-br-lg\">+</span><span></span><span class=\"border-black border-t border-r rounded-tr-lg\">-</span><span></span><span class=\"border-black border-r border-b\">+</span><span class=\"border-black border-b\"></span><span class=\"border-black border-r\"></span><span></span><span class=\"border-black border-r border-b rounded-br-lg\">+</span></div>", 2)),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.ricavi_preventivo) - Number(_ctx.bi_data?.ricavi_preventivo_gamma))), 1)
            ])
          ]),
          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Ordine:", -1)),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("p", _hoisted_30, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.ricavi_preventivo))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            class: "p-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 0))
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("Dettaglio")
            ])),
            _: 1
          }),
          _cache[49] || (_cache[49] = _createElementVNode("div", null, null, -1)),
          _cache[50] || (_cache[50] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Fatture cliente:", -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.fatture_cliente))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'FattureCliente', params: { id: _ctx.id }, query: { nc: 0 } }
          }, {
            default: _withCtx(() => _cache[38] || (_cache[38] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", _hoisted_34, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.fatture_cliente) + Number(_ctx.bi_data?.fatture_cliente_NC) - Number(_ctx.bi_data?.ricavi_preventivo))), 1)
            ])
          ]),
          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Fatture cliente NC:", -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", _hoisted_36, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.fatture_cliente_NC))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'FattureCliente', params: { id: _ctx.id }, query: { nc: 1 } }
          }, {
            default: _withCtx(() => _cache[39] || (_cache[39] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[52] || (_cache[52] = _createElementVNode("div", null, null, -1)),
          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Incassi:", -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("p", _hoisted_38, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.incassato))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'IncassiPagamenti', params: { id: _ctx.id }, query: { incassi: 1 } }
          }, {
            default: _withCtx(() => _cache[40] || (_cache[40] = [
              _createTextVNode("Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[54] || (_cache[54] = _createElementVNode("div", null, null, -1)),
          _cache[55] || (_cache[55] = _createElementVNode("h3", { class: "col-span-5 font-bold" }, "Passivo", -1)),
          _cache[56] || (_cache[56] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Preventivo:", -1)),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", _hoisted_40, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo_gamma))), 1)
            ])
          ]),
          _cache[57] || (_cache[57] = _createStaticVNode("<div></div><div class=\"row-span-5 grid grid-cols-2 grid-rows-8 py-5\"><span class=\"border-black border-t border-r rounded-tr-lg\">-</span><span class=\"border-black border-b\"></span><span class=\"border-black border-r border-b rounded-br-lg\">+</span><span></span><span class=\"border-black border-t border-r rounded-tr-lg\">-</span><span></span><span class=\"border-black border-r border-b\">+</span><span class=\"border-black border-b\"></span><span class=\"border-black border-r\"></span><span></span><span class=\"border-black border-r border-b rounded-br-lg\">+</span></div>", 2)),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("p", _hoisted_42, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo) - Number(_ctx.bi_data?.costi_preventivo_gamma))), 1)
            ])
          ]),
          _cache[58] || (_cache[58] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Ordine:", -1)),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("p", _hoisted_44, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.costi_preventivo))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            class: "p-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 0))
          }, {
            default: _withCtx(() => _cache[41] || (_cache[41] = [
              _createTextVNode("Dettaglio")
            ])),
            _: 1
          }),
          _cache[59] || (_cache[59] = _createElementVNode("div", null, null, -1)),
          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Fatture fornitore:", -1)),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("p", _hoisted_46, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.fatture_fornitore))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'FattureFornitore', params: { id: _ctx.id }, query: { nc: 0 } }
          }, {
            default: _withCtx(() => _cache[42] || (_cache[42] = [
              _createTextVNode("Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("p", _hoisted_48, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.fatture_fornitore) + Number(_ctx.bi_data?.fatture_fornitore_NC) - Number(_ctx.bi_data?.costi_preventivo))), 1)
            ])
          ]),
          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Fatture fornitore NC:", -1)),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("p", _hoisted_50, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.fatture_fornitore_NC))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'FattureCliente', params: { id: _ctx.id }, query: { nc: 1 } }
          }, {
            default: _withCtx(() => _cache[43] || (_cache[43] = [
              _createTextVNode(" Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[62] || (_cache[62] = _createElementVNode("div", null, null, -1)),
          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "px-2 flex items-center text-sm bg-next-gray-md-dark" }, "Pagamenti:", -1)),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("p", _hoisted_52, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$filters.toEuroCurrency(Number(_ctx.bi_data?.pagato))), 1)
            ])
          ]),
          _createVNode(_component_NextButton, {
            component: "router-link",
            class: "p-2",
            to: { name: 'IncassiPagamenti', params: { id: _ctx.id }, query: { incassi: 0 } }
          }, {
            default: _withCtx(() => _cache[44] || (_cache[44] = [
              _createTextVNode("Dettaglio ")
            ])),
            _: 1
          }, 8, ["to"]),
          _cache[64] || (_cache[64] = _createElementVNode("div", null, null, -1))
        ], 512), [
          [_vShow, _ctx.tab == 1]
        ])
      ])
    ])
  ], 64))
}